import React from "react";
import { Button } from "reactstrap";

/**
 * RESET + FILTERS controls for table toolbars (AllCommonFilter modal).
 * Active filter status badge (same chip style as toolbar buttons) above RESET / FILTERS.
 */
const TableFilterToolbarActions = ({
  activeFilterCount = 0,
  onOpenFilters,
  onResetFilters,
}) => {
  const resolvedCount = Math.max(0, Number(activeFilterCount) || 0);
  const countLabel =
    resolvedCount === 1 ? "1 Filter Applied" : `${resolvedCount} Filters Applied`;

  const filtersButtonClassName = [
    "text-dark",
    "d-flex",
    "align-items-center",
    "gap-1",
    "p-0",
    "fw-semibold",
    "no-underline",
    "table-action-icon",
    "table-filter-open-btn",
    resolvedCount > 0 ? "table-filter-open-btn--active" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={
        resolvedCount > 0
          ? "table-filter-toolbar-actions table-filter-toolbar-actions--active"
          : "table-filter-toolbar-actions"
      }
    >
      {/* {resolvedCount > 0 ? (
        <div
          className="table-filter-status-badge"
          aria-live="polite"
          title={countLabel}
        >
          <span className="table-filter-status-dot" aria-hidden />
          <span className="table-filter-status-copy">
            <span className="table-filter-status-count">{resolvedCount}</span>
            {resolvedCount === 1 ? " filter applied" : " filters applied"}
          </span>
        </div>
      ) : null} */}
      <div className="table-filter-buttons-row">
        <Button
          color="link"
          className="text-dark d-flex align-items-center gap-1 p-0 fw-semibold no-underline table-action-icon"
          onClick={onResetFilters}
          type="button"
        >
          <i className="bx bx-x-circle clear fs-5" aria-hidden />
          RESET FILTERS
        </Button>
        <Button
          color="link"
          className={filtersButtonClassName}
          onClick={onOpenFilters}
          type="button"
          aria-label={
            resolvedCount > 0 ? `Open filters, ${countLabel}` : "Open filters"
          }
        >
          {resolvedCount > 0 ? (
            <span className="table-filter-btn-live-dot" aria-hidden >{resolvedCount}</span>
          ) : null}
          <i className="fa fa-filter" aria-hidden />
         ADVANCED FILTERS
        </Button>
      </div>
    </div>
  );
};

export default TableFilterToolbarActions;
